import Link from 'next/link';
import styled from 'styled-components';

export const BreadcrumbsList = styled.ul`
  display: flex;
  padding-bottom: 20px;
  margin-bottom: 20px;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  font-size: 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};

  @media screen and (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    margin-bottom: 0;
    padding: 20px 15px;
  }
`;

export const BreadcrumbsLink = styled(Link).attrs({
  prefetch: false,
  locale: false
})`
  color: ${({ theme }) => theme.colors.text.primary};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.systemColors.blue};
    cursor: pointer;
  }

  &::after {
    content: '';
    width: 3px;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.text.secondary};
    background-image: none;
    border-radius: 50%;
    position: absolute;
    right: -12px;
    top: 7px;
  }
`;

export const BreadcrumbsItem = styled.li`
  position: relative;
  display: inline-block;
  margin-right: 22px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 15px;
  line-height: 1;

  &:last-child {
    margin-right: 0;

    ${BreadcrumbsLink} {
      &::after {
        display: none;
      }
    }
  }
`;
